<template>
  <div>
    <v-card color="" elevation="0" class="">
      <v-divider></v-divider>
      <template>
        <v-tabs color="primary" v-model="tabs" class=" " height="80" background-color="#f4f4f4">
          <div class="d-flex align-center px-4  ">
            <v-icon color="primary" class="" size="">mdi-package-variant-closed</v-icon>
            <h5 class="font-weight-bold headline ml-5">Inventário</h5>
          </div>
          
          <v-tab class="ml-4">Formatos</v-tab>
          
          <v-tab class="ml-4" disabled>
            <span>Pacotes</span>
            <v-chip 
              color="light-blue lighten-3" 
              text-color="white" 
              x-small 
              class="ml-2">
              Em breve
            </v-chip>
          </v-tab>
          
          <v-tab class="ml-4" disabled>
            <span>Inventários</span>
            <v-chip 
              color="light-blue lighten-3" 
              text-color="white" 
              x-small 
              class="ml-2">
              Em breve
            </v-chip>
          </v-tab>
          
          <v-tab class="ml-4" disabled>
            <span>Masters</span>
            <v-chip 
              color="light-blue lighten-3" 
              text-color="white" 
              x-small 
              class="ml-2">
              Em breve
            </v-chip>
          </v-tab>
        </v-tabs>
      </template>
      <v-tabs-items v-model="tabs">
        <v-tab-item>
          <FormatsList></FormatsList>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </div>
</template>

<script>
import FormatsList from '@/components/inventory/FormatsList.vue';

export default {
  name: "InventoryView",
  components: {
    FormatsList,
  },
  data() {
    return {
      tabs: 0,
    };
  },
  mounted() {
    this.loadTabs()
  },
  watch: {
    '$route.params.tab'() {
      this.loadTabs()
    },
    'tabs'(nV) {
      let query = []
      for (let key in this.$route.query) {
        if (nV != 0 && key == 'q') {
          query.push(`${key}=${this.$route.query[key]}`)
        }
      }
      const qstring = query.length ? `?${query.join('&')}` : ''

      if (nV == 0 && this.$route.fullPath != `/app/inventory/formats${qstring}`) {
        this.$router.replace(`/app/inventory/formats${qstring}`)
      }
    }
  },
  methods: {
    loadTabs() {
      if (this.$route.params.tab == 'formats') {
        this.tabs = 0
      }
    }
  },
}
</script>

<style lang="scss" scoped>
* {
  font-family: 'Roboto', sans-serif !important;
}

.v-tab--disabled {
  opacity: 0.6 !important;
}
</style>
